import React, { useEffect, useState } from "react";
import { Button, FormCheck, FormSelect, Pagination, Spinner, Table } from "react-bootstrap";
import { ChevronLeft, Gear, PlusLg } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Auth";
import { fetchApi, range } from "../../../Funciones";

export const Home: React.FC = () => {
	let auth = useAuth();
	let nav = useNavigate();

	//const [filtro, setFiltro] = useState("")
	const [listado, setListado] = useState<any>([])
	const [pagina, setPagina] = useState(0)
	const [porPagina, setPorPagina] = useState(localStorage.getItem("porPagina") ? parseInt(localStorage.getItem("porPagina") + "") : 10)
	const [cargando, setCargando] = useState(false)
	const [total, setTotal] = useState(0)

	var filtradas = listado;
	var paginas = range(1, Math.ceil(total / porPagina) + 1)

	const getData = async () => {
		setCargando(true)
		var data = await fetchApi(auth.user.token, "page", {
			cmd: "list",
			s: "",
			p: pagina,
			pp: porPagina
		})
		setListado(data.listado)
		setTotal(data.total)
		setCargando(false)
	}

	/*useEffect(() => {
		return () => clearTimeout(timeRef.current!)
	}, [])

	const timeRef = useRef<any>(null)
	useEffect(() => {
		clearTimeout(timeRef.current!)
		timeRef.current = setTimeout(() => {
			getData()
		}, 300)
		// eslint-disable-next-line
	}, [auth.user,filtro])*/

	useEffect(() => {
		if (auth.user) {
			//clearTimeout(timeRef.current!)
			getData()
		}
		// eslint-disable-next-line
	}, [auth.user, pagina, porPagina])

	const setHome = async (id: any) => {
		await fetchApi(auth.user.token, "page", {
			cmd: "setHome",
			id: id
		})
		getData()
	}
	const toggleActive = async (id: any) => {
		await fetchApi(auth.user.token, "page", {
			cmd: "toggleActive",
			id: id
		})
		getData()
	}
	const toggleHidden = async (id: any) => {
		await fetchApi(auth.user.token, "page", {
			cmd: "toggleHidden",
			id: id
		})
		getData()
	}
	const toggleUseParentMenu = async (id: any) => {
		await fetchApi(auth.user.token, "page", {
			cmd: "toggleUseParentMenu",
			id: id
		})
		getData()
	}

	return <>
		<Button size="sm" variant="dark" onClick={() => { nav(-1) }} className="my-2"><ChevronLeft /> Volver</Button>
		<h4>Navegación</h4>

		<div className="py-2">
			<Button variant="outline-dark" className="d-inline-block" onClick={() => nav("edit")}>Agregar Página <PlusLg /></Button>
			{/*<div className="d-inline-block ms-4">
				<InputGroup>
					<FormControl type="text" placeholder='Buscar' value={filtro} onChange={(ev) => setFiltro(ev.target.value)} />
					<Button variant="outline-danger" onClick={() => setFiltro("")}><XLg /></Button>
				</InputGroup>
			</div>*/}
			<FormSelect className="d-inline-block w-auto ms-4" title="Por Página" value={porPagina} onChange={(ev) => {
				setPagina(0)
				setPorPagina(parseInt(ev.target.value));
				localStorage.setItem("porPagina", ev.target.value)
			}}>
				<option value={10}>10</option>
				<option value={25}>25</option>
				<option value={50}>50</option>
				<option value={100}>100</option>
			</FormSelect>
			{total > porPagina && <div className="d-inline-block ms-4">
				<Pagination>
					<Pagination.First onClick={() => setPagina(0)} />
					{paginas.map(p => <Pagination.Item key={p} onClick={() => setPagina(p - 1)} active={pagina === p - 1}>{p}</Pagination.Item>)}
					<Pagination.Last onClick={() => setPagina(paginas.length - 1)} />
				</Pagination>
			</div>}
			{cargando && <Spinner animation="border" size="sm" className="d-inline-block ms-4" />}
		</div>

		{listado && listado.length > 0 && <Table bordered hover striped size="sm" className="shadow">
			<thead>
				<tr>
					<th className="text-center">ID</th>
					<th className="text-center">Acciones</th>
					<th>Título</th>
					<th>Descripción</th>
					<th className="text-center">Inicio</th>
					<th className="text-center">Inactiva</th>
					<th className="text-center">Nav. Oculta</th>
					<th className="text-center">Usar Menú Padre</th>
					<th>Resumen</th>
				</tr>
			</thead>
			<tbody>
				{filtradas.map((item: any, i: any) => <tr key={item.id}>
					<td className="text-center" width={60}>{item.id}</td>
					<td className="text-center" width={80} style={{ verticalAlign: "middle" }}>
						<Button size="sm" variant="dark" onClick={() => nav("edit/" + item.id)}><Gear /></Button>
					</td>
					<td>{"- ".repeat(item.level) + item.title}</td>
					<td>{item.description}</td>
					<td width={60} className="text-center home">
						<FormCheck type="switch" checked={item.isHome === "1"} onChange={(ev) => { setHome(item.id) }} />
					</td>
					<td width={60} className="text-center inactive">
						<FormCheck type="switch" checked={item.active !== "1"} onChange={(ev) => { toggleActive(item.id) }} />
					</td>
					<td width={60} className="text-center hidden">
						<FormCheck type="switch" checked={item.hidden === "1"} onChange={(ev) => { toggleHidden(item.id) }} />
					</td>
					<td width={60} className="text-center">
						<FormCheck type="switch" checked={item.useParentMenu === "1"} onChange={(ev) => { toggleUseParentMenu(item.id) }} />
					</td>
					<td>{item.resumen}</td>
				</tr>)}
			</tbody>
		</Table>}

		<div className="py-2">
			{total > porPagina && <div className="d-inline-block ms-4">
				<Pagination>
					<Pagination.First onClick={() => setPagina(0)} />
					{paginas.map(p => <Pagination.Item key={p} onClick={() => setPagina(p - 1)} active={pagina === p - 1}>{p}</Pagination.Item>)}
					<Pagination.Last onClick={() => setPagina(paginas.length - 1)} />
				</Pagination>
			</div>}
		</div>
	</>
}